const getBusinessName = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Info'] && business['Company Info'].ID) {
    return business['Company Info']['Company Name'];
  }
  return null;
};

export default getBusinessName;



// WEBPACK FOOTER //
// ./src/utils/print/getBusinessName.js